import Box from '@mui/material/Box';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import useScreenSize from '../../../util/hooks/useScreenSize';
import { withBaseComponent } from '../hoc/withBaseComponent';
import MobileStoreButton from './MobileStoreButton/MobileStoreButton';

/**
 * @param {object} props
 * @param {object} props.blok
 */
const StoryblokStoreButtonComponent = ({ blok }) => {
  const {
    general = {
      component: {},
    },
    extra = { id: '' },
  } = blok;

  const intl = useIntl();
  const { isMobile } = useScreenSize();

  return (
    <Box justifyContent="space-between">
      <MobileStoreButton
        height={isMobile ? 40 : 50}
        linkProps={{
          title: intl.formatMessage({ id: 'SectionAppStore.android.title' }),
        }}
        store="android"
        width={isMobile ? 130 : 170}
      />
      <MobileStoreButton
        height={isMobile ? 40 : 50}
        linkProps={{ title: intl.formatMessage({ id: 'SectionAppStore.ios.title' }) }}
        store="ios"
        width={isMobile ? 120 : 160}
      />
    </Box>
  );
};

StoryblokStoreButtonComponent.displayName = 'StoryblokStoreButton';
const StoryblokStoreButton = withBaseComponent(StoryblokStoreButtonComponent);

export default memo(StoryblokStoreButton);
